import { TEST_IDS } from '@va/constants';
import { memo } from 'react';

type MonthProps = {
  updateMonth: (key: number) => void;
  months: string[];
};

export const Month = memo(({ updateMonth, months }: MonthProps) => {
  return (
    <div className='flex flex-wrap mt-1.5' data-testid={TEST_IDS.generic.datePicker.monthsPanel}>
      {months.map((month, key) => {
        return (
          <div key={month} className='w-1/2 px-0.5'>
            <span className='flex rounded-md mt-1.5'>
              <button
                type='button'
                className='btn-class relative px-3 py-2 block w-full leading-6 rounded-md bg-white text-xs 2xl:text-sm tracking-wide font-medium transition-colors uppercase border border-transparent hover:bg-white-snow focus:bg-primary-50 focus:border-primary focus:ring-1 focus:ring-primary focus:ring-opacity-0 focus:outline-none '
                onClick={() => updateMonth(key)}
                data-testid={TEST_IDS.generic.buttons.select}
              >
                {month.replace(/<[^>]+>/g, '')}
              </button>
            </span>
          </div>
        );
      })}
    </div>
  );
});
